import React from 'react';
import { Form, Input, Button, Select, Row, Col } from 'antd';
import styles from './ReportFilterForm.scss';
import { AdReportReason } from '../../../../models';

// eslint-disable-next-line max-lines-per-function
const ReportFilterForm = ({ onSubmit, className, form, modules, value }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form.getFieldsValue());
  };
  
  const handleReset = () => {
    form.resetFields();
    onSubmit({});
  };

  return (
    <Form layout="inline" onSubmit={handleSubmit} className={`${styles.form} ${className}`}>
      <Row>
        <Col xs={24} sm={19} md={16} lg={19}>
          <Form.Item>
            {form.getFieldDecorator('code')(
              <Input className={styles.textInput} placeholder={"Kod"} />
            )}
          </Form.Item>
          <Form.Item>
            {form.getFieldDecorator('title')(
              <Input className={styles.textInput} placeholder={"Naslov"} />
            )}
          </Form.Item>
          <Form.Item>
            {form.getFieldDecorator('reporterEmail')(
              <Input className={styles.textInput} placeholder={"Reporter"} />
            )}
          </Form.Item>
          <Form.Item>
            {form.getFieldDecorator('reporteeEmail')(
              <Input className={styles.textInput} placeholder={"Vlasnik"} />
            )}
          </Form.Item>
          <Form.Item>
            {form.getFieldDecorator('module')(
              <Select
                placeholder={"Kategorija"}
                className={styles.moduleDropdown}
              >
                <Select.Option key="" value={null}>
                  {"Kategorija"}
                </Select.Option>
                {modules
                  ? modules.map(module => (
                    <Select.Option key={module.name} value={module.name}>
                      {module.displayName}
                    </Select.Option>
                  ))
                  : null}
              </Select>
            )}
          </Form.Item>

          <Form.Item>
            {form.getFieldDecorator('reason')(
              <Select
                placeholder={"Razlog"}
                className={styles.moduleDropdown}
              >
                <Select.Option key="" value={null}>
                  {"Razlog"}
                </Select.Option>
                {
                  AdReportReason.map(reason => (
                    <Select.Option key={reason.value} value={reason.value}>
                      {reason.name}
                    </Select.Option>
                  ))

                }
              </Select>
            )}
          </Form.Item>

        </Col>
        <Col xs={24} sm={5} md={8} lg={5}>
          <Form.Item>
            <Button className={styles.control} type="primary" htmlType="submit">
              {"Traži"}
            </Button>
          </Form.Item>
          <Form.Item>
            <Button className={styles.control} onClick={handleReset}>
              {"Resetiraj"}
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

ReportFilterForm.defaultProps = {
  className: '',
  modules: [],
};

export default Form.create()(ReportFilterForm);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageReportPage/ReportFilterForm/index.tsx